const getters = {
    userInfo: state => state.user.info,
    name: state => state.user.name,
    roles: state => state.user.roles,
    avatar: state => state.user.avatar
}
export default getters
